<template>
  <div class="CustomerPartner-view-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-button class="btn ml-3" type="button" @click="returnPage">
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Arrows/arrow-left.svg" />
          </span>
          Trở về trước
        </b-button>
        <b-button
          class="btn btn-inactive ml-3"
          type="button"
          v-if="customerPartnerData.isActive && isDeletePermission"
          @click="handleInactive(customerPartnerData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Inactive
        </b-button>
        <b-button
          class="btn btn-active ml-3"
          type="button"
          v-if="!customerPartnerData.isActive && isDeletePermission"
          @click="handleInactive(customerPartnerData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/power.svg" />
          </span>
          Active
        </b-button>
        <b-button
          class="btn btn-success ml-3"
          type="button"
          v-if="isDeletePermission"
          @click.stop="handleUpdate(customerPartnerData)"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/edit-2.svg" />
          </span>
          Chỉnh sửa
        </b-button>
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <b-container fluid class="CustomerPartner-view-page__body mb-6 mt-6">
        
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">Id:</div>
                    <div>
                        {{ customerPartnerData.id }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">Code:</div>
                    <div>
                        {{ customerPartnerData.code }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">IsDeleted:</div>
                    <div>
                        {{ customerPartnerData.isDeleted }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">CreateDatetime:</div>
                    <div>
                        {{ customerPartnerData.createDatetime }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">UpdateDatetime:</div>
                    <div>
                        {{ customerPartnerData.updateDatetime }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">CreatorId:</div>
                    <div>
                        {{ customerPartnerData.creatorId }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">UpdaterId:</div>
                    <div>
                        {{ customerPartnerData.updaterId }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">IsActive:</div>
                    <div>
                        {{ customerPartnerData.isActive }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">Name:</div>
                    <div>
                        {{ customerPartnerData.name }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">RefferalCode:</div>
                    <div>
                        {{ customerPartnerData.refferalCode }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">ContactMethod:</div>
                    <div>
                        {{ customerPartnerData.contactMethod }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">Email:</div>
                    <div>
                        {{ customerPartnerData.email }}
                    </div>
            </b-col>
        </b-row>
        <b-row Class="mt-8">
            <b-col>
                
                    <div class="text-muted">PhoneNumber:</div>
                    <div>
                        {{ customerPartnerData.phoneNumber }}
                    </div>
            </b-col>
            <b-col>
                
                    <div class="text-muted">PartnerId:</div>
                    <div>
                        {{ customerPartnerData.partnerId }}
                    </div>
            </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      isFirstLoad: false,
      CustomerPartnerData: {},
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    isDeletePermission() {
      let roles = this.currentUser?.roles;
      if (roles && roles.length) {
        return roles.includes('Admin');
      } else {
        return false;
      }
    },
  },
  methods: {
    returnPage() {
      this.$router.push({
        name: 'customerPartner_list',
      });
    },
    handleUpdate(item) {
      this.$router.push({
        name: 'customerPartner_detail',
        params: {
          form_type: 'edit',
          id: item.id,
        },
      });
    },
    handleInactive(item) {
      let text = item.isActive ? 'Inactive' : 'Active';
      let btn = item.isActive ? 'btn-inactive' : 'btn-active';
      this.$swal({
        title: '',
        text: `Bạn có chắc muốn ${text} app user ${item.id} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: `${text}`,
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.inactiveItem(item)
              .then(() => {
                this.loadCustomerPartnerData();
                this.$swal(
                  'Thành công!',
                  'Chúc mừng, bạn đã cập nhật thông tin CustomerPartner thành công!',
                  'success',
                );
              })
              .catch(() => {
                this.$swal('Lỗi!', 'Đã có lỗi xảy ra.', 'error');
              });
          }
        }.bind(this),
      );
    },
    async inactiveItem(item) {
      this.loading = true;
      try {
        let payload = new FormData();
        payload.append('id', item.id);
        payload.append('active', !item.isActive);
        await this.$api.put(`CustomerPartner`, payload);
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
    async loadCustomerPartnerData() {
      if (!this.$route.params.id) return;
      try {
        this.loading = true;
        const id = this.$route.params.id;
        let { data } = await this.$api.get(`CustomerPartner/${id}`);
        this.customerPartnerData = data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loadCustomerPartnerData();
  },
};
</script>
